import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Handover } from 'src/app/interfaces/handover';

@Component({
  selector: 'app-home-content-sent-team',
  templateUrl: './home-content-sent-team.component.html',
  styleUrls: ['./home-content-sent-team.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeContentSentTeamComponent implements OnInit {
  @Input() handoversSentTeam: Handover[] | undefined;
  @Input() totalHandoversSentTeam: number | undefined;
  @Input() searchSentTeam: string | undefined;
  @Output() handoversSentTeamWithFilter = new EventEmitter<string>();
  @Output() reloadSentTeam = new EventEmitter<boolean>();
  @Output() eventShowSentPersonal = new EventEmitter<boolean>();

  destinationLabel = 'Hacia';
  textSearch = '';
  constructor() {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  ngOnInit(): void {
    // Agrego esta linea para que Husky deje hacer commit y push.
    this.textSearch = this.searchSentTeam ? this.searchSentTeam : '';
  }

  eventReload(reload: boolean) {
    this.reloadSentTeam.emit(true);
  }
  showSentPersonal() {
    this.eventShowSentPersonal.emit(true);
  }

  getHandoversHomeSentTeamWithFilter(searchText: string): void {
    this.textSearch = searchText;
    this.handoversSentTeamWithFilter.emit(searchText);
  }
}
